import React from 'react';
import { StyledNameInputWrapper, StyledInputTitle, StyledInputCounter } from '../Styled';
import { Input } from '../Input';

interface IInput {
  value: string;
  limit: number;
  isLimitBroken: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const NameInput: React.FC<IInput> = (props): JSX.Element => {
  const { value, limit, isLimitBroken, onChange } = props;

  return (
    <StyledNameInputWrapper>
      <StyledInputTitle>{'Title: '}</StyledInputTitle>
      <Input value={value} onChange={onChange} />
      <StyledInputCounter data-testid="input-counter">
        {isLimitBroken ? <span>{value.length}</span> : value.length}/{limit}
      </StyledInputCounter>
    </StyledNameInputWrapper>
  );
};
